package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.silk.components.style.toModifier
import org.hs_soft.runmynesto.domain.config.Dimen
import org.hs_soft.runmynesto.domain.config.Theme
import org.hs_soft.runmynesto.domain.config.VerticalScrollBehavior
import org.hs_soft.runmynesto.domain.config.autoResponsiveness
import org.hs_soft.runmynesto.domain.config.showContentInOnePage
import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.app_constants.LoadAppConstant
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.util.ApiUtils
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle
import org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component.*
import org.hs_soft.runmynesto.pages.home.sub_page.product.mvi.ProductEvent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px


@Composable
fun ProductTabContent(
    windowSizeMode: WindowSizeModeEnum,
    selectedProduct: GetProduct?,
    selectedSaleGroupId: String?,
    templateCategories: List<TemplateCategoryModel>?,
    profileCountryId: String,
    priceLevels: List<String?>?,
    salesGroup: List<SaleItem>?,
    selectedVat: String?,
    selectedVat2: String?,
    unitSells: List<LoadAppConstant>?,
    event: (ProductEvent) -> Unit,
) {
    LaunchedEffect(Unit) {
        event(ProductEvent.GetProductSalesGroup)
    }

    Column(
        modifier = VerticalScrollBehavior
            .toModifier()
            .showContentInOnePage()
            .fillMaxWidth()
            .padding(
                bottom = Dimen.extraLargePadding,
                top = Dimen.largePadding,
                leftRight = Dimen.extraLargePadding
            )
            .borderRadius(Dimen.semiLargeRadius)
            .border(
                width = Dimen.smallThickness,
                style = LineStyle.Solid,
                color = Theme.ActionDisabledBackground.rgb
            )
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            Row(
                modifier = Modifier
                    .thenIf(
                        windowSizeMode == WindowSizeModeEnum.PHONE,
                        Modifier.fillMaxWidth()
                    )
                    .autoResponsiveness()
            ) {
                Column(
                    modifier = Modifier
                        .thenIf(
                            windowSizeMode == WindowSizeModeEnum.PHONE,
                            Modifier.fillMaxWidth()
                        )
                        .margin(
                            right = if (windowSizeMode == WindowSizeModeEnum.PHONE)
                                0.px else Dimen.extraExtraLargePadding
                        )
                ) {
                    MediumContentTitle(
                        title = Strings.current().generalInfo,
                        marginBottom = Dimen.mediumPadding,
                    )

                    ProductTabGeneralInfo(
                        salesGroup = salesGroup,
                        windowSizeMode = windowSizeMode,
                        selectedSaleGroupId = selectedSaleGroupId,
                        templateCategories = templateCategories,
                        unitSells = unitSells,
                        updateCodeValue = { value ->
                            event(ProductEvent.UpdateProductInfo(
                                title = ApiUtils.Field.code,
                                value = value
                            ))
                        },
                        selectedProduct = selectedProduct,
                        updateActivation = { value ->
                            event(ProductEvent.UpdateProductInfo(
                                title = ApiUtils.Field.isActive,
                                value = value
                            ))
                        },
                        updateReceiptName = { value ->
                            event(ProductEvent.UpdateProductInfo(
                                title = ApiUtils.Field.name,
                                value = value
                            ))
                        },
                        updateSaleGroup = { value ->
                            event(ProductEvent.UpdateProductInfo(
                                title = ApiUtils.Field.salesGroupId,
                                value = value
                            ))
                        },
                        updateTemplateCategory = { value ->
                            event(ProductEvent.UpdateRestaurantData(
                                title = ApiUtils.Field.categoryId,
                                value = value
                            ))
                        },
                        updateAlternativeArticleName = { value ->
                            event(ProductEvent.UpdateRestaurantData(
                                title = ApiUtils.Field.altName,
                                value = value
                            ))
                        },
                        updateUnitSell = { value ->
                            event(ProductEvent.UpdateProductInfo(
                                title = ApiUtils.Field.unitSellCode,
                                value = value
                            ))
                        }
                    )
                }

                CashBidUploadImgContent(
                    cashBidImg = selectedProduct?.img,
                    showImgAIGeneratorDialog = {
                        event(ProductEvent.SetGenerateCashBidAIImgDialogStatus(true))
                    },
                    getImageUrl = { imageUrl, key ->
                        event(ProductEvent.GetCachedBidImg(imageUrl, key))
                    }
                )
            }

            ProductTabDiscountInfo(
                selectedProduct = selectedProduct,
                windowSizeMode = windowSizeMode,
                updateNoDiscountPossible = {value->
                    event(ProductEvent.UpdateProductInfo(
                        title = ApiUtils.Field.isNetto,
                        value = value
                    ))
                },
                updateEmployeeNetItems = { value ->
                    event(ProductEvent.UpdateProductInfo(
                        title = ApiUtils.Field.isNettoForUser,
                        value = value
                    ))
                },
                updateEmployeeConsumption = { value ->
                    event(ProductEvent.UpdateProductInfo(
                        title = ApiUtils.Field.isEmployeeArticle,
                        value = value
                    ))
                },
            )

            ProductPriceContent(
                windowSizeMode = windowSizeMode,
                selectedProduct = selectedProduct,
                profileCountryId = profileCountryId,
                priceLevels=priceLevels,
                selectedVat = selectedVat,
                selectedVat2 = selectedVat2,
                updatePrice = { value ->
                    event(ProductEvent.UpdateProductPrice(
                        title = ApiUtils.Field.price,
                        value = value
                    ))
                },
                updatePriceInCafe = { value ->
                    event(ProductEvent.UpdateProductPrice(
                        title = ApiUtils.Field.priceInCafe,
                        value = value
                    ))
                },
                updateVatCode = { value ->
                    event(ProductEvent.UpdateProductInfo(
                        title = ApiUtils.Field.codeMWSt,
                        value = value
                    ))
                },
                updateVatCode2 = { value ->
                    event(ProductEvent.UpdateProductInfo(
                        title = ApiUtils.Field.codeMWSt2,
                        value = value
                    ))
                }
            )
        }
    }
}








